import { axiosClient } from "@/lib/axios";
import { HttpError } from "@/types/error";
import {
  PublicAnnouncement,
  UpdateAnnouncementDto,
} from "@classview/shared-types";
import { UseMutationOptions, useMutation } from "@tanstack/react-query";

const updateAnnouncement = async ({
  id,
  announcement,
}: {
  id: string;
  announcement: UpdateAnnouncementDto;
}): Promise<PublicAnnouncement> => {
  const response = await axiosClient.patch(`announcements/${id}`, announcement);
  return response.data;
};

function useUpdateAnnouncement(
  mutationOptions?: UseMutationOptions<
    PublicAnnouncement,
    HttpError,
    { id: string; announcement: UpdateAnnouncementDto }
  >,
) {
  return useMutation({
    mutationFn: updateAnnouncement,
    ...mutationOptions,
  });
}

export { useUpdateAnnouncement };
